import { render, staticRenderFns } from "./ghost-slot.vue?vue&type=template&id=7511d4de&"
import script from "./ghost-slot.vue?vue&type=script&lang=js&"
export * from "./ghost-slot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JG\\jg\\IWMS5.0\\SRM\\GIT\\SRM.VUE\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7511d4de')) {
      api.createRecord('7511d4de', component.options)
    } else {
      api.reload('7511d4de', component.options)
    }
    module.hot.accept("./ghost-slot.vue?vue&type=template&id=7511d4de&", function () {
      api.rerender('7511d4de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/demo/components/container/ghost-slot.vue"
export default component.exports